import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchListItemTitleStyled } from './styles/GlobalSearchListItemTitleStyled'
import {
  type GlobalSearchResultTypeEnum,
  GlobalSearchResultTypes,
} from '../../../../../../value-objects/enums'
import { useFormatGlobalSearchResultTypeLabel } from '../../hooks/useFormatGlobalSearchResultTypeLabel'

interface IGlobalSearchListItemTitleProps {
  type: GlobalSearchResultTypeEnum
  id: string
  label?: Nullable<string>
}

export const GlobalSearchListItemTitle = ({
  type,
  id,
  label,
}: IGlobalSearchListItemTitleProps) => {
  const intl = useProcurifyIntl()
  const formatResultTypeLabel = useFormatGlobalSearchResultTypeLabel()

  if (type === GlobalSearchResultTypes.CONTRACT) {
    const contractTitle = label ?? intl.formatMessage(messages.untitledContract)
    return (
      <GlobalSearchListItemTitleStyled noWrap textEllipsis className='fs-mask'>
        {contractTitle}
      </GlobalSearchListItemTitleStyled>
    )
  }

  const usePlainId =
    type === GlobalSearchResultTypes.VENDOR ||
    type === GlobalSearchResultTypes.CATALOG_ITEM

  if (usePlainId) {
    return (
      <GlobalSearchListItemTitleStyled noWrap textEllipsis className='fs-mask'>
        {id}
      </GlobalSearchListItemTitleStyled>
    )
  }

  const typeLabel = formatResultTypeLabel(type)
  const title = label
    ? intl.formatMessage(messages.titleWithExtraIdentifier, {
        label: typeLabel,
        id,
        extraIdentifier: label,
      })
    : intl.formatMessage(messages.titleWithoutExtraIdentifier, {
        label: typeLabel,
        id,
      })

  return (
    <GlobalSearchListItemTitleStyled noWrap textEllipsis className='fs-mask'>
      {title}
    </GlobalSearchListItemTitleStyled>
  )
}
